
import { Component, Vue, Prop, Watch, Model } from "vue-property-decorator";
// import { objAny } from "@/common/common-interface";
import { getStatGunKvs } from "@/api/oms-operation-service";
@Component
export default class SelectPile extends Vue {
  @Prop({ default: 200 }) private width!: number;
  @Prop({ default: false }) private isSelect!: boolean;
  @Prop({ default: "" }) private pilePkId!: number | string;
  @Watch("pilePkId")
  getVisible() {
    this.getGunList();
  }
  @Watch("gunId")
  getValue() {
    if (this.gunPkId != this.gunId) {
      this.gunPkId = this.gunId;
    }
  }
  @Model("value", { type: String }) private gunId!: string;
  private gunList: object[] = [];

  private gunPkId = "";

  async getGunList(): Promise<void> {
    if (this.pilePkId == "" || !this.pilePkId) {
      this.gunList = [];
      this.gunPkId = "";
    } else {
      this.gunPkId = this.gunId;
      const ret = await getStatGunKvs({ pilePkId: this.pilePkId });
      if (ret.status === this.$config.apiStatus) {
        if (this.isSelect && ret.data && ret.data.length > 0) {
          this.gunList = ret.data;
          this.gunPkId = ret.data[0].gunPkId;
          this.$emit("value", this.gunPkId);
          this.$emit("on-change", this.gunPkId);
        } else {
          this.gunList = [];
        }
      }
    }
  }

  public selectStation(val: string): void {
    val = val == undefined ? "" : val;
    this.gunPkId = val;
    this.$emit("value", val);
    this.$emit("on-change", val);
  }
  mounted() {
    this.gunPkId = this.gunId;
    if (this.pilePkId != "") {
      this.getGunList();
    }
  }
}
